document.addEventListener('DOMContentLoaded', function () {
  var mapContainer = document.getElementById('breweries-map');
  if (!mapContainer) return;

  var mapSection = document.getElementById('breweries-map-section');
  var mapWrap = document.querySelector('.breweries-map-wrap');
  if (!mapSection || !mapWrap) return;

  if (typeof mapboxgl === 'undefined') {
    console.warn('[Breweries Map] mapboxgl is undefined. Check theme.liquid Mapbox include.');
    return;
  }

  // ✅ last brewery section id (controls "behind footer")
  var lastChapterName = 'london-bridge';

  function setBehindFooter(isBehind) {
    if (isBehind) mapContainer.classList.add('behind-footer');
    else mapContainer.classList.remove('behind-footer');
  }

  mapboxgl.accessToken =
    'pk.eyJ1IjoiZ3VuamFucmFpayIsImEiOiJja2Z2N3dkcmkwODk4MnFwN3pnd3k3dzIyIn0.HZp4zYL_txhS0Buvv0NmAg';

  var map = new mapboxgl.Map({
    container: 'breweries-map',
    style: 'mapbox://styles/mapbox/streets-v11',
    center: [135.2650868, 35.9065745],
    zoom: 5.5,
    bearing: 60,
    pitch: 30
  });

  map.addControl(new mapboxgl.NavigationControl());

  // IMPORTANT: keys must match <section id="..."> in Liquid
  // NOTE:
// baker = Dassai
// aldgate = Kubota
// london-bridge = Dewazakura

  var chapters = {
    home: { center: [135.2650868, 35.9065745], zoom: 5.5, bearing: 30, pitch: 30 },
    baker: { bearing: 27, center: [131.9953376, 34.126525], zoom: 7, pitch: 0 },
    aldgate: { duration: 2000, center: [138.7725093, 37.396894], bearing: 0, zoom: 9, pitch: 0 },
    'london-bridge': { bearing: 90, center: [140.3675333, 38.3516015], zoom: 9, speed: 0.6, pitch: 0 }
  };

  // Markers
  var geojson = {
    type: 'FeatureCollection',
    features: [
      { type: 'Feature', geometry: { type: 'Point', coordinates: [131.9953376, 34.126525], popup: 'ASAHI SHUZO - DASSAI' } },
      { type: 'Feature', geometry: { type: 'Point', coordinates: [138.7725093, 37.396894], popup: 'ASAHI SHUZO - KUBOTA BREWERY' } },
      { type: 'Feature', geometry: { type: 'Point', coordinates: [140.3675333, 38.3516015], popup: 'DEWAZAKURA BREWERY' } }
    ]
  };

  /* ========= OPTION 1: Auto-open popup on active chapter ========= */

  var chapterToPopupKey = {
    baker: 'ASAHI SHUZO - DASSAI',
    aldgate: 'ASAHI SHUZO - KUBOTA BREWERY',
    'london-bridge': 'DEWAZAKURA BREWERY'
    // home: (no popup)
  };

  var markers = {};

  geojson.features.forEach(function (feature) {
    var el = document.createElement('div');
    el.className = 'marker';

    var popup = new mapboxgl.Popup({
      offset: 25,
      closeButton: false,
      closeOnClick: false
    }).setText(feature.geometry.popup);

    var marker = new mapboxgl.Marker(el)
      .setLngLat(feature.geometry.coordinates)
      .setPopup(popup)
      .addTo(map);

    markers[feature.geometry.popup] = { marker: marker, popup: popup };
  });

  function closeAllPopups() {
    Object.keys(markers).forEach(function (k) {
      markers[k].popup.remove();
    });
  }

  function openPopupForChapter(chapterName) {
    var key = chapterToPopupKey[chapterName];
    if (!key || !markers[key]) return;

    closeAllPopups();
    markers[key].popup.addTo(map);
  }

  /* =============================================================== */

  var activeChapterName = 'home';

  function setActiveChapter(chapterName) {
    if (chapterName === activeChapterName) return;
    if (!chapters[chapterName]) return;

    map.easeTo(Object.assign({}, chapters[chapterName], { duration: 900 }));

    var newActive = document.getElementById(chapterName);
    var oldActive = document.getElementById(activeChapterName);

    if (newActive) newActive.classList.add('active');
    if (oldActive) oldActive.classList.remove('active');

    activeChapterName = chapterName;

    openPopupForChapter(chapterName);
  }

  // Trigger-line activation (matches wineries)
  function isElementActive(id) {
    var el = document.getElementById(id);
    if (!el) return false;

    var rect = el.getBoundingClientRect();
    var triggerY = 350;

    return rect.top <= triggerY && rect.bottom > triggerY;
  }

  function clearFixedInline() {
    mapContainer.style.left = '';
    mapContainer.style.width = '';
  }

  function lockFixedToRightColumn() {
    var wrapRect = mapWrap.getBoundingClientRect();
    if (wrapRect.width <= 50) return;

    mapContainer.style.left = wrapRect.left + 'px';
    mapContainer.style.width = wrapRect.width + 'px';
  }

  function updateSticky() {
    if (window.matchMedia('(max-width: 768px)').matches) {
      mapContainer.classList.remove('change');
      mapContainer.classList.remove('at-bottom');
      setBehindFooter(false);
      clearFixedInline();
      window.requestAnimationFrame(function () { map.resize(); });
      return;
    }

    if (mapWrap.offsetWidth <= 50) return;

    var sectionRect = mapSection.getBoundingClientRect();
    var sectionTop = sectionRect.top + window.scrollY;

    // ✅ stop based on wrapper bottom (prevents disappearing near footer)
    var wrapRect = mapWrap.getBoundingClientRect();
    var wrapperBottom = (wrapRect.top + window.scrollY) + wrapRect.height;

    var topOffset = 100;
    var startStick = sectionTop + 190;
    var bottomBuffer = 40;

    var mapHeight = mapContainer.getBoundingClientRect().height || 800;
    var stopStick = wrapperBottom - mapHeight - topOffset - bottomBuffer;
    if (stopStick <= startStick + 10) stopStick = startStick + 11;

    var inStickyRange = window.scrollY >= startStick && window.scrollY < stopStick;
    var pastStop = window.scrollY >= stopStick;

    setBehindFooter(pastStop && activeChapterName === lastChapterName);

    if (inStickyRange) {
      mapContainer.classList.add('change');
      mapContainer.classList.remove('at-bottom');
      lockFixedToRightColumn();
    } else if (pastStop) {
      mapContainer.classList.remove('change');
      mapContainer.classList.add('at-bottom');
      clearFixedInline();
    } else {
      mapContainer.classList.remove('change');
      mapContainer.classList.remove('at-bottom');
      setBehindFooter(false);
      clearFixedInline();
    }

    window.requestAnimationFrame(function () { map.resize(); });
  }

  function onScroll() {
    var chapterNames = Object.keys(chapters);
    for (var i = 0; i < chapterNames.length; i++) {
      var chapterName = chapterNames[i];
      if (isElementActive(chapterName)) {
        setActiveChapter(chapterName);
        break;
      }
    }
    updateSticky();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () {
    if (mapContainer.classList.contains('change')) lockFixedToRightColumn();
    onScroll();
  });

  map.on('load', function () {
    onScroll();
    updateSticky();
  });

  updateSticky();
});
